import React, {useEffect, useState} from "react";
import {supabase} from "../../supabase";
import {useTranslation} from "react-i18next";
import LanguageDialog from "../../components/LanguageDialog";
import AuthLogo from "./AuthLogo";
import {Row} from "../../components/styled";
import {Button, Card, CardContent, Stack, TextField, Typography} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";

export default function () {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("");
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [langSwitch, setLangSwitch] = useState<boolean>(false);

    async function login() {
        setLoading(true);
        const {data: {user}, error} = await supabase.auth.signInWithOtp({
            email: email,
        });
        if (!error && !user) {
            setLoading(false);
            setSubmitted(true)
            return
        }
        if (error) {
            setLoading(false);
            alert(error.message);
            return
        }
    }

    const location = useLocation();

    useEffect(() => {
        const authenticateUser = async () => {
            // Extract the token from the URL hash
            const hash = location.hash.substring(1); // Remove the '#' character
            const params = new URLSearchParams(hash);
            const accessToken = params.get('access_token');
            const refreshToken = params.get('refresh_token');
            console.log(accessToken, refreshToken);

            if (accessToken && refreshToken) {
                try {
                    // Use the tokens to authenticate the user
                    const { error} = await supabase.auth.setSession({
                        access_token: accessToken,
                        refresh_token: refreshToken,
                    });

                    if (error) throw error;
                    setTimeout(() => {
                        navigate("/menu/main")
                    }, 500);


                } catch (error) {
                    console.error('Authentication error:', error.message);
                }
            }
        };
        authenticateUser();
    }, [location]);

    return <Card sx={{
        minWidth: 300,
        textAlign: "center",
        opacity: 0.95
    }}>
        <CardContent>
            <AuthLogo/>
            {!submitted && <Stack
                sx={{
                    paddingHorizontal: 1,
                    marginBottom: 1,
                }}
            >
                <Typography
                    variant={"h3"}
                >
                    {t("auth.login")}
                </Typography>
                <Typography variant={"body2"}>{t("std.email")}</Typography>
                <TextField
                    style={{marginTop: 0}}
                    variant={"outlined"}
                    placeholder={t("auth.emailPlaceholder")}
                    value={email}
                    autoCapitalize="none"
                    autoComplete={"username"}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                    onClick={() => {
                        login();
                    }}
                    variant={"contained"}
                    style={{
                        marginTop: "1em",
                    }}
                    disabled={loading}
                >
                    {loading ? t("std.loading") : t("auth.getMagicLink")}
                </Button>
            </Stack>}
            {submitted && <Row
                style={{
                    marginTop: "1em",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            ><Typography
                variant={"h5"}
                style={{textAlign: "center"}}>
                {t("auth.checkMailLogin")}
            </Typography></Row>}

            <Row style={{
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Button
                    onClick={() => {
                        navigate("/ForgetPassword");
                    }}
                >
                    {t("auth.forget")}
                </Button>
            </Row>

            {langSwitch && <LanguageDialog setSwitchLang={setLangSwitch}/>}
        </CardContent>
    </Card>;
}
